export const MODULE = 'manage_guests';
export const MERGE = 'guest_merge';
export const AUDIT = 'guest_audit';
export const CUSTOM_FIELD = 'custom_guest_fields';
export const VIEW_ADDRESS = 'show_guest_address';
